<template>
  <div>
    <!-- 主订单关联售后列表（通用组件：按主订单id查询全部关联售后单） -->
    <el-dialog title="关联售后订单" :visible="visible" width="960px" top="6vh" append-to-body
      :close-on-click-modal="false" @close="handleClose">
      <!-- 主订单摘要 -->
      <div class="parent-summary" v-if="declaration && declaration.id">
        <el-row :gutter="12">
          <el-col :span="8">
            <span class="detail-label">报单编号</span>
            <span class="detail-value">{{ declaration.number || '-' }}</span>
          </el-col>
          <el-col :span="8">
            <span class="detail-label">客户姓名</span>
            <span class="detail-value">{{ declaration.customName || '-' }}</span>
          </el-col>
          <el-col :span="8">
            <span class="detail-label">客户电话</span>
            <span class="detail-value">{{ declaration.customMobile || '-' }}</span>
          </el-col>
        </el-row>
      </div>

      <el-table :data="tableData" v-loading="tableLoading" border stripe size="small" style="width: 100%;"
        max-height="480">
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column prop="afterSaleNo" label="售后编号" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="售后来源" width="130" align="center">
          <template slot-scope="scope">{{ sourceLabel(scope.row.sourceType) }}</template>
        </el-table-column>
        <el-table-column label="售后状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status)" size="mini">{{ statusLabel(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="engineerName" label="工程师" width="90" align="center">
          <template slot-scope="scope">{{ scope.row.engineerName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="faultPhenomenon" label="故障现象" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.faultPhenomenon || '-' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="150" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="130" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-view" size="small" @click.stop="handleDetail(scope.row)">详情
            </el-button>
            <el-button type="text" icon="el-icon-tickets" size="small" @click.stop="handleViewOrder(scope.row)">工单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="empty-tip" v-if="!tableLoading && tableData.length === 0">该主订单暂无关联售后订单</div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 售后订单详情（复用通用详情组件） -->
    <detail-dialog :visible.sync="detailVisible" :after-sale-id="detailId" />

    <!-- 售后服务工单（复用售后列表页的工单组件，跨模块互查场景下只读，隐藏审核等操作按钮） -->
    <after-sale-view-order :visibleOrder.sync="orderVisible" :orderId="orderRowId" :declarationInfo="orderRow"
      :readonly="true" @refresh="loadList" />
  </div>
</template>

<script>
import {
  AFTER_SALE_STATUS_DIC,
  AFTER_SALE_SOURCE_DIC,
  statusTagType
} from '@/const/salesCloud/afterSaleOption';
import { listByParent } from '@/api/salesCloud/afterSale';
import DetailDialog from './detailDialog.vue';
import AfterSaleViewOrder from './viewOrder.vue';

export default {
  name: 'AfterSaleListDialog',
  components: { DetailDialog, AfterSaleViewOrder },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 主订单（报单）行数据，需包含 id
    declaration: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      detailVisible: false,
      detailId: '',
      // 售后服务工单弹窗
      orderVisible: false,
      orderRowId: '',
      orderRow: {}
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadList();
      }
    }
  },
  methods: {
    statusTagType,
    // 统一解包：网关 data 可能是对象或 JSON 字符串
    parseData(res) {
      if (!res) return null;
      const data = res.data;
      if (typeof data === 'string') {
        try {
          return JSON.parse(data);
        } catch (e) {
          return null;
        }
      }
      return data;
    },
    statusLabel(val) {
      const item = AFTER_SALE_STATUS_DIC.find(i => i.value === val);
      return item ? item.label : (val || '-');
    },
    sourceLabel(val) {
      const item = AFTER_SALE_SOURCE_DIC.find(i => i.value === val);
      return item ? item.label : (val || '-');
    },
    formatTime(val) {
      if (!val) return '-';
      const t = Number(val);
      if (!t) return '-';
      const d = new Date(t);
      const p = n => (n < 10 ? '0' + n : '' + n);
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
    },
    loadList() {
      this.tableData = [];
      if (!this.declaration || !this.declaration.id) {
        this.$message.error('缺少主订单id');
        return;
      }
      this.tableLoading = true;
      listByParent(this.declaration.id).then(res => {
        if (res && res.code == '200') {
          const data = this.parseData(res);
          // 兼容直接返回数组或分页结构两种形式
          this.tableData = Array.isArray(data) ? data : ((data && data.rows) || []);
        } else {
          this.$message({
            showClose: true,
            message: (res && res.message) || '查询失败',
            type: 'error'
          });
        }
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    handleDetail(row) {
      this.detailId = row.id;
      this.detailVisible = true;
    },
    // 查看售后服务工单（含实际用料清单）
    handleViewOrder(row) {
      this.orderRowId = row.id;
      this.orderRow = row;
      this.orderVisible = true;
    },
    handleClose() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.parent-summary {
  background: #f4f8ff;
  border: 1px solid #d9ecff;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 14px;

  .el-col {
    line-height: 28px;
    display: flex;
    align-items: baseline;
  }
}

.detail-label {
  color: #606266;
  font-size: 13px;
  min-width: 60px;
  margin-right: 6px;
}

.detail-value {
  color: #303133;
  font-size: 13px;
  flex: 1;
  min-width: 0;
  word-break: break-all;
}

.empty-tip {
  color: #909399;
  text-align: center;
  padding: 14px 0 2px;
}

.dialog-footer {
  text-align: right;
}
</style>
